import { TableRow, TableRowProps } from "@mui/material"
import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface RowProps extends TableRowProps {
    children: ReactNode
}

export default function Row({ children, ...rest }: RowProps) {
    return (
        <TableRow 
            {...rest}
            className={twMerge("", rest.className)} 
        >
            {children}
        </TableRow>
    )
}